import React, { useEffect, useMemo, useState } from 'react';
import { getOffers } from '../../api/Public/merchant';

import styles from './MerchantProfil.module.css';
import { putHistory } from '../../api/Client/history';

const Offers = ({ id, history, setHistory, setWindow, setPopUp }) => {
    const [offers, setOffers] = useState([]);
    
    const offerHistory = useMemo(() => {
        if (!history?.history_data) return [];
        if (!history.month || history.month !==  new Date().getMonth() + 1) { 
            putHistory(new Date().getMonth() + 1, "");
            setHistory(prev => ({...prev, history_data: ""}));
            return [];
        }
        return history.history_data.split("-").map(Number);
    }, [history, setHistory]);

    useEffect(() => {
        (async () => {
            const res = await getOffers({ id: Number(id) });
            if (Array.isArray(res.data)) {
                const filteredOffers = res.data.filter(
                    offer => offer.activated === 1 && offer.title && offer.title.trim() !== ''
                );
                setOffers(filteredOffers);
            }
        })();
    }, [id, offerHistory]);

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Nos offres<span className={styles.star}>*</span></h1>

            <div className={styles.suggestions}>
                {offers.length === 0 ? (
                    <p>Aucune offre disponible pour le moment.</p>
                ) : (
                    offers.map((offer, index) => (
                        <div key={index} className={styles.offers} 
                        onClick={() => {
                            if (!offerHistory.includes(offer.id)) {
                                setPopUp(offer);
                                setWindow(true);
                            }
                        }}>
                            <img
                                className={styles.coupon}
                                src = {offerHistory.includes(offer.id) ? `/Merchant/deal${offer.index}_disable.png` : `/Merchant/deal${offer.index}.png`}
                                alt='Coupon'
                            />
                            <h1 className={styles.label}>{offer.title}</h1>
                            <p className={styles.paragraph}>
                                {offer.description || 'Aucune description disponible.'}
                            </p>
                        </div>
                    ))
                )}
            </div>
            <p className={styles.disclamer}>*Toutes les offres sont utilisables une seule fois par mois et ne peuvent pas être cumulées avec les offres disponibles chez le commerçant</p>
        </div>
    );
};

export default Offers;
